import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
let token = localStorage.getItem("auth"); // assuming you stored token under "auth"
let user = null;
if (token) {
  try {
    user = jwtDecode(token);
  } catch (err) {
    token = null;
    localStorage.removeItem("auth");
  }
}

const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginHandler: (state, action) => {
      const { user, token } = action.payload;
      if (user !== undefined) {
        state.user = user;
      }
      if (token !== undefined) {
        state.token = token;
        localStorage.setItem("auth", token);
      }
      state.isAuthenticated = true;
    },
    logoutHandler: (state, action) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { loginHandler, logoutHandler, setUser } = authSlice.actions;

export default authSlice.reducer;
